import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { Network } from '@ionic-native/network/ngx';
// import { Dialogs } from '@ionic-native/dialogs/ngx'; DELETAR DO APP SE COMPILAR
import { NavController, Platform, ModalController, ToastController, MenuController, LoadingController } from '@ionic/angular';
import { NativePageTransitions } from '@ionic-native/native-page-transitions/ngx';

// Carregar variaveis do ambiente
import { environment } from 'src/environments/environment';

// Carregar serviços adicionais
import { ModelService } from 'src/app/services/model.service';
import { LanguageService } from 'src/app/services/language.service';

import  * as Pristine from 'pristinejs';
import  * as UIkit from 'uikit';
import  * as Axios from 'axios';
import  * as Moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class HelpersService {
  
  axios: any = Axios; // Declrar axios para ser importavel em outros components (sem necessidade de importar novamente a lib)
  moment: any = Moment;

  UIkit: any = UIkit;

  environment: any = environment;
  
  languageActive: any = null;
  platformActive: any = null;
  alertActive:    any  = null; // Modal Ukit ou Cordova Dialog
  toastActive:    any = null;
  loadingActive:  any = null;
  

  networkOnline: any = false;
  networkCheckTime: number = 1500;

  spinnerButtonActive: any = null;
  documentBody: HTMLElement;
  multilanguage: boolean = false;
 
  transtitions: object = {
    go: {
      direction: 'up',
      duration: 500,
      slowdownfactor: 3,
      slidePixels: 20,
      iosdelay: 100,
      androiddelay: 150,
      fixedPixelsTop: 0,
      fixedPixelsBottom: 60
    },

    back: {
      direction: 'up',
      duration: 500,
      slowdownfactor: 3,
      slidePixels: 20,
      iosdelay: 100,
      androiddelay: 150,
      fixedPixelsTop: 0,
      fixedPixelsBottom: 60
    },

    root: {
      direction: 'up',
      duration: 500,
      slowdownfactor: 3,
      slidePixels: 20,
      iosdelay: 100,
      androiddelay: 150,
      fixedPixelsTop: 0,
      fixedPixelsBottom: 60
    },

    up: {
      direction: 'up',
      duration: 500,
      slowdownfactor: 3,
      slidePixels: 20,
      iosdelay: 100,
      androiddelay: 150,
      fixedPixelsTop: 0,
      fixedPixelsBottom: 60
    },

    down: {
      direction: 'up',
      duration: 500,
      slowdownfactor: 3,
      slidePixels: 20,
      iosdelay: 100,
      androiddelay: 150,
      fixedPixelsTop: 0,
      fixedPixelsBottom: 60
    }
  }

  constructor(

    private network: Network,
    // private dialogs: Dialogs,
    
    // publico e acessivel a components que carreguem o helperservice (quase todos) 
    public navController: NavController,
    public platform: Platform,
    public menuController: MenuController, 
    public router: Router, 
    public activatedRoute: ActivatedRoute,
    public modalController: ModalController, 
    public toastController: ToastController,
    public alertController: AlertController,
    public loadingController: LoadingController,
    private nativePageTransitions: NativePageTransitions,

    public languageService: LanguageService,
    public modelService: ModelService,

    ) { 

     
      this.multilanguage = this.environment.appMultilanguage;
      this.documentBody = document.body;
    }
  
  /**
   * Checar conexão com a internet e interface de rede
   *
   * @return Promise<any>
   * @author Demerson Carvalho
   */
  // async networkCheck(): Promise<any> {

  //     const documentBody = document.body;

  //     const alertData = {
  //       message:    await this.languageService.get('MESSAGE_NETWORK_CONNECTION_ERROR'),
  //       buttonText: await this.languageService.get('TRY_AGAIN')
  //     };

  //     // Checar primeiro no navegador 
  //     this.networkOnline = window.navigator.onLine;

  //     // console.log(this.networkOnline);

  //     // Adicionar escutador aos eventos de conxão / desconexão
  //     this.network.onDisconnect().subscribe(() => {
  //       this.networkOnline = false;
  //       return this.networkCheck();
  //     });
      
  //     this.network.onConnect().subscribe(() => { 
  //       this.networkOnline = true;
  //       // this.toastPresent('internet ligada', 'success');
  //     });

  //     if(this.networkOnline  == false) {
        
  //       documentBody.classList.remove('tmx-page-loaded');
        
  //       return setTimeout(() => { 
          
  //         // Exibir alerta caso este já não seja visível
  //         if(this.alertActive == null) this.alertShow(alertData);
          
  //         // Alterar o tempo de rechecagaem para 5 segundos após a primeira tentativa
  //         this.networkCheckTime = 5000;

  //         // Reexcutar a função
  //         this.networkCheck();  

  //       }, this.networkCheckTime);

  //     } else {
  //       return setTimeout(() => {
  //         documentBody.classList.add('tmx-page-loaded');
  //       }, 300);

  //     } 
  // }

  async networkCheck(required: boolean = true, alertShow: boolean = true, networkCheckTimeout: number = 300): Promise<any> {

    // Caso a página não necessite de conexão, para a função aqui
    if(required == false) {
      setTimeout(() =>   this.documentBody.classList.add('tmx-page-loaded') , networkCheckTimeout)
        return true;
    }

    const alertData = {
      message:    await this.languageService.get('MESSAGE_NETWORK_CONNECTION_ERROR'),
      buttonText: await this.languageService.get('TRY_AGAIN')
    };

    // Checar primeiro no navegador 
    this.networkOnline = window.navigator.onLine; // da pau na 4g (resolvido na versao 72, tem que dar permissao no app)
    // this.networkOnline = true;

    // console.log(this.networkOnline);

    // Adicionar observador aos eventos de desconexão
    let disconnectSubscription = this.network.onDisconnect().subscribe(() => {
      this.networkOnline = false;
      this.networkCheck();
    });
    
    // Adicionar observador aos eventos de conexão
    let connectSubscription = this.network.onConnect().subscribe(() => { 
      this.networkOnline = true;
    });

    if(this.networkOnline  == false) {
      
      this.documentBody.classList.remove('tmx-page-loaded');
      
      setTimeout(() => { 
        
        // Exibir alerta caso este já não seja visível
        if(this.alertActive == null && alertShow == true) this.alertShow(alertData);
        
        // Alterar o tempo de rechecagaem para 5 segundos após a primeira tentativa
        this.networkCheckTime = 5000;

        // Remover observador de não conexão
        disconnectSubscription.unsubscribe();

        // Reexcutar a função
        this.networkCheck();  

      }, this.networkCheckTime);

    } else {

      setTimeout(() => {
        this.documentBody.classList.add('tmx-page-loaded');

        // Remover observable de conexão
        connectSubscription.unsubscribe();

      }, networkCheckTimeout);

    }

    return this.networkOnline;
  }

  /**
   * Retornar os dados da timezone do usuário
   * 
   * @returns {Promise}
   * @author Demerson Carvalho
   */
   async userTimezoneGet(): Promise<string> {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }


  /**
   * Coletar os dados da plataforma e setar no storage
   *
   * @return Promise<any> 
   * @author Demerson Carvalho
   */
  async platformDataGet(): Promise<any> {
      // console.log('salvou os dados da plataforma');
      
      this.platformActive = (this.platformActive == null) ? await this.modelService.getRoot('platform') : this.platformActive;

      // Se não existir dados em this.platformActive e nenhum dado disponivel no storage, setar os dados
      return (this.platformActive == null) ? await this.platformDataSet() : this.platformActive;
  }

  /**
   * Coletar os dados da plataforma e setar no storage
   *
   * @return Promise<any> 
   * @author Demerson Carvalho
   */
  async platformDataSet(): Promise<any> {

      // Coletar os dados da plataforma
      const platformName    = this.platform.is('android') ? 'android' : this.platform.is('ios') ? 'ios' : this.platform.is('desktop') ? 'desktop' : 'other';
      const plataformType   = (platformName  == 'android' || platformName == 'ios' || this.platform.is('mobileweb')) ? 'mobile' : 'desktop';
      const platformCordova = (plataformType == 'mobile' ||  this.platform.is('cordova')) ? true : false;

      // Passar o valor para platform active
      this.platformActive = {
          'name': platformName,
          'type': plataformType,
          'cordova': platformCordova
      };
    
    // setar no storage
    await this.modelService.setRoot('platform', this.platformActive);
    
    // retornar platform active
    return this.platformActive;
  }

  /**
   *Instanciar o formulário e adicionar componentes da validaçao
   *
   * @return <Void>
   * @author Demerson Carvalho
   */
  async formValidatePrepare(): Promise<any> {
   
      const forms           = document.querySelectorAll('[data-jsmx-form]'),
            requiredMessage = (this.multilanguage === true) ? await this.languageService.get('MESSAGE_REQUIRED_FILED') : 'Campo Obrigatório';
      
     
      if(forms != null) {
        forms.forEach( (form) => {
          
          if(form.hasAttribute('data-jsmx-initialized') == false) {
            let inputContainers = form.querySelectorAll('.jsmx-input-container');
              
              inputContainers.forEach( (container: any) => {
                  let input = container.querySelector('input, ion-input') as HTMLInputElement,
                      isRequired = input.required;
                  
                  if(isRequired == true) {
                
                    let error: HTMLElement = document.createElement('div'),
                        message = (container.getAttribute('data-jsmx-formValidatorMessage') != null) ? container.getAttribute('data-jsmx-formValidatorMessage') : (container.querySelector('.jsmx-formValidatorMessage')) ? container.querySelector('.jsmx-formValidatorMessage').textContent : requiredMessage;

                   
                      input.classList.add('form-control');
                      input.setAttribute('data-pristine-required-message', message);
              
                      error.textContent = message;
                      error.setAttribute('class', 'pristine-error jsmx-input-message uk-animation-slide-top-small-ll');
                    
                      container.appendChild(error);
                  }
                  
                });


                form.setAttribute('data-jsmx-initialized', 'true');
              } 
        });
      }
   
  }

  /**
   *Aguardar submissão do form e validar (com Pristine JSs)
   *
   * @Param <Any> form
   * @return <Any>
   * @author Demerson Carvalho
   */
  async formValidate(form: any): Promise<any> {
    
    await this.formValidatePrepare();

    const pristineConfig = {
      classTo: 'jsmx-input-container',   // class of the parent element
      errorClass: 'jsmx-input-invalid',  // class of the parent element where the error/success class is added
      successClass: 'jsmx-input-valid',  // class of the parent element where the error/success class is added
      errorTextParent: 'form-group',  // class of the parent element where error text element is appended
      errorTextTag: 'div', // type of element to create for the error text
      errorTextClass: 'jsmx-input-message'  // class of the error text element
   }

    const formToValidate = new Pristine(form, pristineConfig);

    return formToValidate.validate();
  }

  /**
   * Validar email
   *
   * @Param  <string> Email
   * @return <any> Promise
   * @author Demerson Carvalho
   */
  async emailValidate(email: string): Promise<any> {
    const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return regex.test(email);
  }

  /**
   * Formatar valores para o padrão PT-BR
   * 
   * @Param <Number> Value
   * @return <any>
   * @author Demerson Carvalho
   */
  formatMoney(value: number): any {
    return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  /**
   * Formatar Datas para o padrão de um idioma especificado ou do idioma ativo
   * 
   * @Params <Any> Date, <format> format <string>, laguage (opcional, caso vazio pega o valor do idioma ativo)
   * @return Promise <Any>
   * @author Demerson Carvalho
   */
  async formatDateToLocale(date: any, format: string = 'L', language ?: any): Promise<any> {
  language = (language == null) ? this.languageActive : language;

  // Caso ainda seja nulo o valor
  language = await this.modelService.getRoot('language') || await this.languageService.check();

  // Atualizar o idioma ativo
  this.languageActive = language;

  // Retornar os dados
  return this.moment(date).locale(language).format(format);
  };

  /** DELETAR ESTA
   * Formatar Datas para o padrão PT-BR
   * 
   * @Params <Any> Date, <Boolean> localFormate <string>, showTime = false (padrão não mostrar horário)
   * @return Promise <Any>
   * @author Demerson Carvalho
   */
  async formatDate(date: any, convertToEnUsForm: boolean = false, dateTime: boolean = false): Promise<any> {
    const language = await this.languageService.check();

    date = (typeof(date) == 'object' && date.tagName == 'INPUT') ? date.value : date;
    
    let localFormate = (convertToEnUsForm == true || language == 'en') ?  'en-US' :  'en-US';

    // se o idioma for inglês, a data já vem no padrão adequado
    if(language  != 'en') {
      // verificar se foi passado um string ou um objecto (o input inteiro)
  
      // Converter para o formato americano
      if(convertToEnUsForm == true) {
          let dateArray = date.toString();
              dateArray = dateArray.split('/');

          date = [dateArray[1], dateArray[0], dateArray[2]].join('/');
      }
    }
 
    // Verificar se a date é um string, caso seja transformar em data
    date = (typeof(date) == 'string') ? new Date(date.trim()) : date;
 
    if(dateTime == false) {
      const removeTime = new Intl.DateTimeFormat(localFormate);
      date = removeTime.format(date);
    }
    
   
    return date.toLocaleString(localFormate);
  };

  /**
   * Trocar separados de data / por -
   * 
   * @Params <Any> Date
   * @return <String> Date
   * @author Demerson Carvalho
   */
  dateFormatToInputValue(date: any) {
    return this.moment(date).format('YYYY-MM-DD');
  }

  /**
   * Formatar string para o padrão númerico separando casas decimais por ponto
   * Remover caracteres alfa do valor
   * 
   * @Params <Any> event - pode ser o evento ou elemento diretamente
   * @return <Any>
   * @author Demerson Carvalho
   */
  async formatNumber(value: any)  {
    return (value.toString().indexOf(',') > -1) ?  Number(value.replace(',','.')) :  Number(value);  
  }

  /**
   * Calcular diferença entre duas datas, retorna o resultado em dias
   *
   * @Params <Any> finalDate, <Any> initialDate
   * @return <Any>
   * @author Demerson Carvalho
   */
  dateDiferenceCalculate(finalDate: any, initialDate: any, diffIn: string = 'days'): any {
      initialDate = this.moment(initialDate);
      finalDate = this.moment(finalDate);

      // Retornar a diferença
      return initialDate.diff(finalDate, diffIn);

      // initialDate = new Date(initialDate);
      // finalDate   = new Date(finalDate);

      // // const diffTime = Math.abs(finalDate - initialDate);
      // const diffTime = Math.round(finalDate - initialDate);
      // const diffDays = Math.ceil(diffTime / (1000  * 60  * 60  * 24)); 
    
      // return diffDays;
  }

  /**
   * Exibir Modal de Alerta
   * 
   * @Param <Object> data - variaveis para o modal
   * @return Promise <any>
   * @author Demerson Carvalho
   */
  async alertShow(modalData: object = {}, forceTranslate: boolean = false, functionReturn ?: any): Promise<any> {
    
    // forçar false para translate, caso o app não seja multi idioma
    forceTranslate = (this.multilanguage === true && forceTranslate === true) ? true : false;

    const status = (modalData['status'] == null) ? 'warning' : modalData['status'];
    
    // Passar os valores do modalData para data
    const data = Object.assign({
          title:      (this.multilanguage === true) ? (forceTranslate === false) ? await this.languageService.get('ATTENTION') : 'ATTENTION' : 'Atenção',
          titleIcon:  `<ion-icon class="uk-margin-small-right" color="${status}" name="alert-circle-outline" style="font-size: 20px !important"></ion-icon>`,
          message:    (this.multilanguage == true) ? 'MESSAGE_ERROR_TRY_AGAIN' : 'Algo deu errado tente novamente',
          status: 'warning',
          buttonText: (this.multilanguage === true) ? 'CLOSE' : 'Fechar',
          cssClass: '',
        }, modalData);

      // Forçar a tradução do conteúdo antes de montar a saída
      if(forceTranslate === true) { 
          data.title      = await this.languageService.get(data.title);
          data.message    = await this.languageService.get(data.message);
          data.buttonText = await this.languageService.get(data.buttonText);
      }

      data.title = `<h3 class="uk-h4 uk-text-bold uk-margin-remove uk-margin-small-bottom uk-flex uk-flex-middle">${data.titleIcon}${data.title}</h3>`;

      
      // Se a plataforma for cordova exibir alerta com Dialog Native, caso n usar o modal do Uikit
      if(this.platform.is('cordova') || 1 == 1) { 

        if(this.alertActive != null) return true;
        
        // Ajustar o titule
        // data.title = `${data.title}`;
        // alert-head
        this.alertActive = await this.alertController.create({
          cssClass: data.cssClass,
          header:  '',
          // subHeader: 'Subtitle',
          message:  data.message,
          buttons: [data.buttonText]
        });
 
        // Por o conteudo do header
        this.alertActive.querySelector('.alert-head').innerHTML = data.title;

        this.alertActive.querySelector('.alert-wrapper').style.minWidth = '300px';

        await this.alertActive.present().then(() => {
          this.alertActive.onWillDismiss().then(() => {
         
            this.alertActive = null; 
            return (functionReturn != null) ? functionReturn() : null;
          })
        });
        
        // Com o dialogs do cordova
        // this.alertActive = this.dialogs.alert(data.message, data.title, data.buttonText)
        
        // .then(() => { 
        //   this.alertActive = null; 
        //   return (functionReturn != null) ? functionReturn() : null;
        // });
        
      } else {
        
          this.alertActive = UIkit.modal.alert(data.title + data.message, {
            labels: { ok : data.buttonText}
          }) 
          .then(() => {
            this.alertActive = null;
            return (functionReturn != null) ? functionReturn() : null;
          })
      }

      if(this.spinnerButtonActive != null) this.spinnerHide(null, false);
  };

  /**
   * Exibir Toast (Notificação)
   * 
   * @Param <Object> data - variaveis para o modal
   * @return Promise <any>
   * @author Demerson Carvalho
   */
  async toastShow(toastData: object, present: boolean = true) {

    if(present === false) return false;

    // console.log(this.platform); 

    const options: any = Object.assign({
          message: '', 
          header: '',
          cssClass: '',
          // mode: '' ,
          animated: true,
          color: 'primary', 
          position: 'top' , 
          timeout: 2000,
          // enterAnimation: '',
          // leaveAnimation: '',
    }, toastData);

    this.toastActive = await this.toastController.create({
        message: options.message,
        color: options.color,
        duration: options.timeout,
        position: options.position
    });
    
    await this.toastActive.present();

    // await this.toastActive.present().then(() => {
    //      // Remover o spinner, caso exista
    //      if(this.spinnerButtonActive != null) this.spinnerHide();
    // });
  }

  /**
   * Exibir Toast (Notificação)
   * 
   * @Param <Object> data - variaveis para o modal
   * @return Promise <any>
   * @author Demerson Carvalho
   */
  async toastHidde(): Promise<void> {
      setTimeout(async () => {

         if(this.toastActive != null) {
            await this.toastActive.dismiss().then(() => { this.toastActive = null;  })
         }  

      }, 5000);
     
  }


  /**
   * Exibir Modal de Alerta
   * 
   * @Param <Object> data - variaveis para o modal
   * @return Promise <any>
   * @author Demerson Carvalho
   */

  /**
   * Exibir Spinner dentro de um elemento html
   *
   * @Param <Any> element
   * @return <Void>
   * @author Demerson Carvalho
   */
  spinnerShow(element: any): void {

      element.parentNode.classList.add('uk-flex');
      element.parentNode.classList.add('uk-flex-center');

      let spinner: HTMLIonSpinnerElement = element.querySelector('.tmx-spinner'),
          elementInnerHTML: HTMLSpanElement = element.querySelector('.jsmx-elemetHtml');

      if(spinner == null) {
        spinner = document.createElement('ion-spinner');
        spinner.name  = 'crescent';
        spinner.color = 'light';
       

        // jsmx-spinner ou tmx-spinner, necessária para ocultar o html atual do botão
        spinner.className = 'uk-hidden tmx-spinner';

          // Encapsular o html original do botão, caso ainda n tenha sido feito
          if(elementInnerHTML == null) {
            
            elementInnerHTML = document.createElement('span');
            elementInnerHTML.className = 'jsmx-elemetHtml tmx-touch-disabled';

            elementInnerHTML.innerHTML = element.innerHTML;

            element.innerHTML = '';
            element.appendChild(elementInnerHTML);
          }
          
         
          element.insertBefore(spinner, elementInnerHTML);

      }

      // Desabilitar o botão
      element.setAttribute('disabled', '');

      element.classList.add('jsmx-spinnerActive');

      // Desocultar o spinner
      spinner.classList.remove('uk-hidden');
      
      // Setar como elemento ativo
      this.spinnerButtonActive = element;
  }

  /**
   * Ocultar Spinner dentro de um elemento html
   *
   * @Param <Any> element
   * @return <Void>
   * @author Demerson Carvalho
   */
  spinnerHide(element ?: any, status: any = true): void  {
      element = (element == null) ? this.spinnerButtonActive : element;
    
      if(element != null) {

        element =  element.classList.contains('tmx-spinner') ? element.closest('.jsmx-spinnerActive') : element;
        let spinner: any = element.querySelector('ion-spinner'),
            statusIcon: any = null;

        if(status != null) {
          // remover o disabled caso o elemento possua
          element.removeAttribute('disabled');
          
          statusIcon = document.createElement('ion-icon');

          setTimeout(() => {  
            statusIcon.name    = (status === true) ?  'checkmark-outline' : 'close-outline';
            statusIcon.classList.add('jsmx-spinnerIcon');
            statusIcon.classList.add('uk-animation-slide-top-small-ll');
            element.classList.add((status === true) ? 'jsmx-spinnerSuccess' : 'jsmx-spinnerError');
            element.insertBefore(statusIcon,  element.querySelector('ion-spinner'));
            
          }, 200); 
      
        }
        
        setTimeout(() => {  
            // Caso o elemento seja um spinner, subir para o container (ion-button)
          
            // remover o disabled caso o elemento possua
            element.removeAttribute('disabled');
           
            // Remover as classes de estadus do spinner 
            element.classList.remove('jsmx-spinnerSuccess');
            element.classList.remove('jsmx-spinnerError');
            element.classList.remove('jsmx-spinnerActive');
        
            // ocultar o spinner
            if(element.querySelector('ion-spinner') != null) {
                element.querySelector('ion-spinner').classList.add('uk-hidden');
            }
            
            // Remover o icone de status, caso exista
            if(statusIcon != null) {
              statusIcon.remove();
            }
          
          
          
          // remover o disabled caso o elemento possua
          // if(element.hasAttribute('disabled')) element.removeAttribute('disabled');

          // // Adicionar a classe hidden ao spinner
          // if(element.classList.contains('tmx-spinner')) {  
          //     // caso o elemento seja o próprio spinner CONTINUAR AQUI
          //     element.classList.add('uk-hidden');
          //     // element.remove();
              
          //     element.closest('.jsmx-spinnerActive').classList.remove('jsmx-spinnerSucces');
          //     element.closest('.jsmx-spinnerActive').classList.remove('jsmx-spinnerError');
          //     element.closest('.jsmx-spinnerActive').classList.remove('jsmx-spinnerActive');
          // } else {
          //     // caso o spinner seja um node do elemento
          //     element.querySelector('.tmx-spinner').classList.add('uk-hidden');
          //     // element.querySelector('.tmx-spinner').remove();
              
          //     // Remover classes de sucesso e erro
          //     element.classList.remove('jsmx-spinnerSucces');
          //     element.classList.remove('jsmx-spinnerError');
          // }
            
        }, 1500); 

        this.spinnerButtonActive = null;
      }
  }

  /**
   * Exibir loading
   *
   * @Param <Any> element
   * @return <Void>
   * @author Demerson Carvalho
   */
  async loadingShow(options: object = {}, functionReturn ?: any): Promise<any> {
    
    if(this.loadingActive !== null) return false;

    const componentOptions: any = Object.assign({
          showBackdrop: false,
          translucent: true,
          spinner: 'crescent',
          cssClass: 'tmx-spinner-only tmx-loading',
          duration: 0, // Infinito
        }, options);

      this.loadingActive = await this.loadingController.create(componentOptions);
      await  this.loadingActive.present();

      const { role, data } = await  this.loadingActive.onDidDismiss();
      console.log('Loading dismissed with role:', role);
  }
  

  /**
   * Gerar código randomico
   *
   * @Param <number> length - padrão 6
   * @return <string> Code
   * @author Demerson Carvalho
   */
  codeRandomGenerate(length: number = 6) {
    let random: string = '',
        possible: string = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

      for(let i = 0; i < length; i++) {
        random += possible.charAt(Math.floor(Math.random()  * possible.length));
      }

      return random;		
  };

  /**
    Ajustar mensagens recebidas da API
   *
   * @Param <Any> messages
   * @return <any>
   * @author Demerson Carvalho
   */
  messagesAdjust(messages: any): any {
    let message = '';

    Object.entries(messages).forEach(function(key) {
        if(key[1].toString().length > 0) {
          message +=  key[1];
        }
    });

    return message;
  }

  /**
   * Função para navegar entre as páginas
   * 
   * @Params <string> route, <Booelan> paramsOnId = false (padrão não procurar parametros no id do Elementi), 
            <String> action = go || back (definir a direção da rota),
            <Boolean> transition = true  (Exibir transição com animação),
            <String> backTo (Opcional - Enviar um url de volta para a página de destino) 

   * @return <any>
   * @author Demerson Carvalho
   */
  async routeNavigate(route: string, paramsOnId: boolean = false, action: string  = 'go', transition: boolean = true, backTo?: string): Promise<any> {
    
    this.documentBody.classList.remove('tmx-page-loaded');
    
    if(event != null) {
      const eventTarget = event.target as HTMLElement;

        if(paramsOnId == true && eventTarget.id.indexOf(':') > 0) {
          let params = eventTarget.id.split(':');

          this.modelService.create(params[0], params[1]);
          route += (route.indexOf('?') !== -1) ?  '&' + params[0] +'='+params[1] : '?' + params[0] +'='+params[1];
      }
    }
    
    // transition = true;

    // if(transition === true) {
    //    let transitionOptions = this.transtitions[action];
    //        this.nativePageTransitions.slide(transitionOptions);
    // }
    

    // Aguardar o toastHidde (caso exista algum toast ativo, aguarda o dismiss)
    await this.toastHidde();
    
    //// Usando o navController do Ionic
        if(backTo != null) {
          let backRoute = this.router.url;
              backRoute =  backRoute.replace('/', '');
        
          if(backRoute != null) {
              route += (route.indexOf('?') !== -1) ? '&backTo='+ backTo : '?backTo=' + backTo;
          }
        }
        
        const navigate = 
            (action == 'go') ? 
                this.navController.navigateForward(route) : 
            (action == 'up' || action == 'push') ? 
                this.navController.navigateRoot(route) : 
            (action == 'back') ? 
                this.navController.navigateBack(route)    : 
            (action == 'root') ?
                this.navController.navigateRoot(route)    :
                this.navController.navigateForward(route);
        
        navigate.then(() => {
          setTimeout(() => {
            this.documentBody.classList.add('tmx-page-loaded');
          }, 400);

      });

    //  await this.router.navigate([route],  { queryParams: { backTo: backTo }} ).then( async () => {

    //   await this.menuController.enable(true);

    //     setTimeout(() => {
    //         this.documentBody.classList.add('tmx-page-loaded');
    //     }, 400);
            
    //  });

  }

  /**
   * Função para consultar e retornar valor na rota
   *
   * @Params <String> paramType, <String> paramName 
   * @return <string | any> data.value
   * @author Demerson Carvalho
   */
  routeSnapshot(paramType: string | any = null, paramName: string): any {
      const data: any = {success: false,  value: null},
            queryTypesArray: any = ['query', 'queryparams', 'queryparam', 'search', 'getparam', 'get'],
            queryParam: any = (paramType != null && queryTypesArray.indexOf(paramType.toLowerCase()) !== -1) ? true : false; 

      
      data.success =  (this.router.url.indexOf(paramName) !== -1) ? true : false; 

      if(data.success === true) {
        data.value = (queryParam === true) ? this.activatedRoute.snapshot.queryParams[paramName] : this.activatedRoute.snapshot.params[paramName];
        data.value = (data.value.length == 0) ? null : data.value;
      }

      return data.value;
  }

  /**
   * Pegar Rota Ativa
   * 
   * @return Promise<Any>
   * @author Demerson Carvalho
   */
  async routeActiveGet() {
    return this.router.url;
  }
  
  /** 
   * Normalizar rota
   *
   * @return Promise<Any> 
   * @author Demerson Carvalho
   */
  async routeNormalize(routeName: string, paramName ?: string): Promise<any> {
      
      if(paramName != null) {
          const value = await this.modelService.get(paramName);
      
        // redireciona para a rota adequeada caso o parametro exista
        if(value != null) {
            return this.navController.navigateRoot('/'+routeName+'?'+paramName+'='+value);
          }
      }  
      
      return this.navController.navigateRoot('/'+routeName);
  }

  /**
   * Enviar um card com a mensagem de erro (nenhum dado encontrado) ao corpo da view original
   *
   * @Params <Any> Message = Nenhum dado encontrado (padrão), <string> cardType = default (padrão)
   * @return <Void>
   * @author Demerson Carvalho
   */
  noDataFound(message: string = 'Nenhum Dado Encontrado', cardType: string = 'default'): void {
    
    const ionPageActive = document.querySelector('.ion-page:not(.ion-page-hidden)'),
          ionModalActive = document.querySelector('.jsmx-modal-full, .jsmx-modal');

    const hasError = ionPageActive.querySelector('#jsmx-cardError');

    if(hasError == null && !document.body.classList.contains('jsmx-requestError')) {
        let cardError = document.createElement('div'),  
            button = document.createElement('a'),
            main = (ionModalActive == null) ? ionPageActive.querySelector('#tmx-main') : ionModalActive.querySelector('#tmx-main'),
            firstChild = main.querySelector('div');

          cardError.setAttribute('class', 'uk-card uk-card-small uk-margin-top uk-card-body uk-text-center uk-animation-slide-top-small-ll tmx-box-shadow-compact uk-card-'+cardType);
          cardError.id = 'jsmx-cardError';
          cardError.innerHTML = message;

          button.setAttribute('class', 'uk-button uk-button-success uk-margin-top');
          button.setAttribute('onclick', 'window.location.reload()');
          button.textContent = 'Tentar novamente';
          cardError.appendChild(button);
          
          (firstChild == null) ? main.appendChild(cardError) : main.insertBefore(cardError, firstChild);
    }
  }
}
